import { REGEX_EMAIL, REGEX_TELEPHONE_PORTABLE } from '@/configuration/regexConf';

export default function checkSiSignableCommun(contact, messages) {
  if (!contact) {
    messages.push({
      message: 'detail.dcfSignable.erreurContactDonneurDordreRequis',
    });
  } else {
    if (!contact.nom || contact.nom === null) {
      messages.push({
        message: 'detail.dcfSignable.erreurNomContact',
      });
    }
    if (!contact.prenom || contact.prenom === null) {
      messages.push({
        message: 'detail.dcfSignable.erreurPrenomContact',
      });
    }
    if (!REGEX_EMAIL.test(contact.email)) {
      messages.push({
        message: 'detail.dcfSignable.erreurEmail',
      });
    }
    if (!REGEX_TELEPHONE_PORTABLE.test(contact.portable)) {
      messages.push({
        message: 'detail.dcfSignable.erreurPortable',
      });
    }
  }
}
